// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e56fee0f","457":"75bbec47","748":"8099a38d","967":"d69d66d8"}[chunkId] + ".chunk.js";
};